// ── Logger — only outputs in development ─────────────────────────────────────
// In production (Vercel build), process.env.NODE_ENV === 'production'
// and all warn/log calls are silently swallowed.
// Errors are always surfaced regardless of environment.

const isDev = process.env.NODE_ENV === 'development';

const logger = {
  /** Always shown — real errors that need attention in any environment */
  error: (...args) => console.error(...args),

  /** Development only — non-critical warnings, noisy in production */
  warn: (...args) => { if (isDev) console.warn(...args); },

  /** Development only — general debug logging */
  log: (...args) => { if (isDev) console.log(...args); },
};

export default logger;
